import * as THREE from 'three';
import { OrbitControls } from 'orbit-controls';
// USED TO VISUALIZE THE shelf  (ONLY FOR TESTING PURPOSES)

// TODO: refactor this to use the same function as shelf-visualization.js
function viewPacking3D({ shelf, placements = [], freeSpaces = [], width, height }) {
	/* ---------- scene boilerplate ---------- */
	const canvas = document.querySelector('.shelf-visualization__canvas--3d');
	const renderer = new THREE.WebGLRenderer({ canvas, antialias: true });
	renderer.outputColorSpace = THREE.SRGBColorSpace;
	renderer.toneMapping = THREE.NoToneMapping;
	renderer.toneMappingExposure = 1;

	renderer.setSize(width, height);
	renderer.setPixelRatio(Math.min(devicePixelRatio, 2));

	const scene = new THREE.Scene();
	scene.background = new THREE.Color('#ded1b1'); // light gray background
	const mm = 0.01; // 1 mm = 1 cm·0.01 (keeps coords small)

	const camera = new THREE.PerspectiveCamera(50, canvas.clientWidth / canvas.clientHeight, 1, 100);

	const controls = new OrbitControls(camera, renderer.domElement);
	controls.enableDamping = true;
	const cameraOffsetFactor = 4; // 2x the shelf depth
	camera.position.set((shelf.width / 2) * mm, (shelf.height * mm) / 2, shelf.depth * cameraOffsetFactor * mm);
	const cameraTarget = new THREE.Vector3((shelf.width / 2) * mm, (shelf.height / 2) * mm, (shelf.depth / 2) * mm);
	camera.lookAt(cameraTarget);
	controls.target.copy(cameraTarget);
	const axesHelper = new THREE.AxesHelper(50);
	// axesHelper.setColors(X=green, Y=red, Z=blue);
	// #544336
	axesHelper.setColors(0x544336, 0x544336, 0x544336);

	scene.add(axesHelper);
	/* ---------- wireframe shelf ---------- */
	shelf.bins.forEach((bin) => {
		const g = new THREE.BoxGeometry(bin.width * mm, bin.height * mm, bin.depth * mm);
		const wire = new THREE.LineSegments(new THREE.EdgesGeometry(g), new THREE.LineBasicMaterial({ color: 0x544336 }));
		wire.position.set(
			(bin.position.x + bin.width / 2) * mm,
			(bin.position.y + bin.height / 2) * mm,
			(bin.position.z + bin.depth / 2) * mm,
		);
		scene.add(wire);
	});

	/* ---------- each product box ---------- */
	placements.forEach((p) => {
		const geo = new THREE.BoxGeometry(p.width * mm, p.height * mm, p.depth * mm);
		const mat = new THREE.MeshLambertMaterial({
			color: new THREE.Color(p.color || 0x00ff00).convertSRGBToLinear(),
		}); // default green
		const m = new THREE.Mesh(geo, mat);

		const wire = new THREE.LineSegments(new THREE.EdgesGeometry(geo), new THREE.LineBasicMaterial({ color: 0x000000 }));
		wire.position.set(
			(p.position.x + p.width / 2) * mm,
			(p.position.y + p.height / 2) * mm,
			(p.position.z + p.depth / 2) * mm,
		);
		// wire.scale.set(1.01, 1.01, 1.01); // scale up a bit
		scene.add(wire);
		m.position.set(
			(p.position.x + p.width / 2) * mm,
			(p.position.y + p.height / 2) * mm,
			(p.position.z + p.depth / 2) * mm,
		);
		scene.add(m);
		// const label = makeTextSprite(p.variantID, '#000'); // black letters
		// label.position.set((p.width / 2) * mm, (p.height * mm) / 2 + 0.01, 1); // 1 mm above top
		// m.add(label);
	});
	/* ---------- free spaces ---------- */
	const testColors = [
		'navy',
		'maroon',
		'darkgreen',
		'indigo',
		'saddlebrown',
		'darkslategray',
		'midnightblue',
		'darkred',
		'darkmagenta',
		'darkolivegreen',
		'darkblue',
		'darkcyan',
		'darkslateblue',
		'darkgoldenrod',
	];
	freeSpaces.forEach((f, index) => {
		const geo = new THREE.BoxGeometry(f.width * mm, f.height * mm, f.depth * mm);
		const freeSpaceWire = new THREE.LineSegments(
			new THREE.EdgesGeometry(geo),
			new THREE.LineBasicMaterial({ color: testColors[index % testColors.length] }),
		);
		freeSpaceWire.position.set(
			(f.position.x + f.width / 2) * mm,
			(f.position.y + f.height / 2) * mm,
			(f.position.z + f.depth / 2) * mm,
		);
		scene.add(freeSpaceWire);
	});

	/* ---------- lighting & resize ---------- */
	scene.add(new THREE.AmbientLight(0xffffff, 1));
	const sun = new THREE.DirectionalLight(0xffffff, 1);
	sun.position.set(1, 2, 3);
	scene.add(sun);

	window.addEventListener('resize', () => {
		camera.aspect = canvas.clientWidth / canvas.clientHeight;
		camera.updateProjectionMatrix();
		renderer.setSize(canvas.clientWidth, canvas.clientHeight);
	});

	/* ---------- tiny render loop ---------- */
	(function tick() {
		controls.update();
		renderer.render(scene, camera);
		requestAnimationFrame(tick);
	})();
}
class ShelfVisualization extends HTMLElement {
	constructor() {
		super();
		this.app = null;
		this.viewportScale = 0.6;
		this.shelfBorderThickness = 10;
		this.arrowOffset = 10;
		this.arrowSize = 24;
		this.arrowSpacing = 12;
		this.scale = 1;
		this.pad = 40;
		this.shelf = null;
		this.placements = [];
		this.shelfLevelImageUrl = this.dataset.shelfLevelImageUrl;
		this.shelfSizingArrowImageUrl = this.dataset.shelfSizingArrowImageUrl;
		this.imageUrls = [this.shelfLevelImageUrl, this.shelfSizingArrowImageUrl];
		this.offsetX = 0;
		this.offsetY = 0;
		this.orientation = 'FRONT';
		this.heightWording = this.dataset.heightWording;
		this.widthWording = this.dataset.widthWording;
		this.depthWording = this.dataset.depthWording;
		this.buttonWrapperNode = this.querySelector('.shelf-visualization__content-wrapper');
		this.orderFormControlsWrapperNode = this.querySelector('.order-form__controls');
		this.allCanvas = this.querySelectorAll('canvas');
	}
	async connectedCallback() {
		await this.createPixiApp();
	}

	disconnectedCallback() {
		this.app?.destroy(true);
	}
	switchCanvas(view) {
		this.allCanvas = this.querySelectorAll('canvas');
		this.allCanvas.forEach((canvas) => {
			if (view === '3D') {
				if (canvas.classList.contains('shelf-visualization__canvas--3d')) {
					canvas.style.display = 'block';
				} else {
					canvas.style.display = 'none';
				}
			} else {
				if (canvas.classList.contains('shelf-visualization__canvas--3d')) {
					canvas.style.display = 'none';
				} else {
					canvas.style.display = 'block';
				}
			}
		});
	}
	async rerender({ view = 'FRONT', shelf, placements, imageMap = {} }) {
		this.switchCanvas(view);
		if (view === '3D') {
			const height = this.clientHeight || 500;
			// TODO USE SAME recomputeLayout AS IN 2D
			viewPacking3D({
				shelf,
				placements,
				colorMap: this.colorMap,
				width: this.clientWidth,
				height: height - this.buttonWrapperNode.offsetHeight - this.orderFormControlsWrapperNode.offsetHeight,
			});
			return;
		}
		this.shelf = shelf;
		this.placements = [...placements];
		this.imageMap = imageMap;
		this.orientation = view;
		this.clearDrawings();
		this.recomputeLayout();
		this.imageUrls = [...new Set([...Object.values(imageMap), ...this.imageUrls])];
		await this.loadAssets();
		// TODO: why 2 times?
		this.clearDrawings();
		this.drawShelf();
		this.drawSizingArrows();
		this.sortPlacements();
		this.drawJars();
	}
	sortPlacements() {
		this.placements.sort((a, b) => {
			return this.orientation === 'FRONT' ? a.position.z - b.position.z : a.position.x - b.position.x;
		});
	}
	clearDrawings() {
		if (!this.app) return;
		this.app.stage.removeChildren();
	}
	recomputeLayout() {
		if (!this.shelf || !this.app) return;
		const shelfXDimension = this.orientation === 'FRONT' ? this.shelf.width : this.shelf.depth;
		const viewportH = this.viewportScale * window.innerHeight;
		const canvasW = this.clientWidth;
		const shelfAspect = shelfXDimension / this.shelf.height;
		const canvasH = Math.min(viewportH, Math.max(canvasW / shelfAspect, 400));
		const usableW = canvasW - this.pad * 2;
		const usableH = canvasH - this.pad * 2;
		this.scaleX = usableW / shelfXDimension;
		this.scaleY = usableH / this.shelf.height;
		// TODO: MOVE MAX SCALE TO A VARIABLE
		this.scale = Math.min(1.8, this.scaleX, this.scaleY);
		this.offsetX = (canvasW - shelfXDimension * this.scale) / 2;
		this.offsetY = (canvasH - this.shelf.height * this.scale) / 2;

		if (this.app.renderer.width !== canvasW || this.app.renderer.height !== canvasH) {
			this.app.renderer.resize(canvasW, canvasH);
			const buttonWrapperHeight = this.buttonWrapperNode?.offsetHeight || 0;
			const orderFormControlsWrapperHeight = this.orderFormControlsWrapperNode?.offsetHeight || 0;
			this.style.height = `${canvasH + buttonWrapperHeight + orderFormControlsWrapperHeight}px`;
			this.style.maxHeight = `${canvasH + buttonWrapperHeight + orderFormControlsWrapperHeight}px`;
		}
		this.TransformFactor = {
			maxWidth: this.app.renderer.width,
			maxHeight: this.app.renderer.height,
			startX: this.offsetX,
			startY: this.offsetY,
			scale: this.scale,
		};
	}
	async loadAssets() {
		if (!this.app || this.imageUrls.length === 0) return;
		this.assetLoader = PIXI.Assets;
		const allPromises = this.imageUrls.map((url) => {
			return this.assetLoader.load(url);
		});
		await Promise.all(allPromises);
	}
	async createPixiApp() {
		if (this.app) return;
		this.app = new PIXI.Application();
		await this.app.init({
			// TODO color from dataSet
			background: '#ded1b1',
			roundPixels: true,
		});
		if (this.buttonWrapperNode) {
			this.buttonWrapperNode.insertAdjacentElement('afterend', this.app.canvas);
		} else {
			this.appendChild(this.app.canvas);
		}
	}
	drawShelf() {
		if (!this.shelf || !this.app) return;

		const shelfImage = this.assetLoader.get(this.shelfLevelImageUrl);
		if (!shelfImage) return;

		// TODO: FOR EACH BINS
		// shelfPartIndex
		this.shelf.bins.forEach((bin) => {
			const binSprite = new PIXI.Sprite(shelfImage);
			const binInner = new PIXI.Graphics();
			const transformedBin = bin.transformToPixiJs(this.TransformFactor);
			const binXAxisLength = this.orientation === 'FRONT' ? transformedBin.width : transformedBin.depth;
			binInner.fill('#f5f0e6');
			binInner.rect(0, 0, binXAxisLength, transformedBin.height);
			binInner.fill();
			binInner.x = this.orientation === 'FRONT' ? transformedBin.position.x : transformedBin.position.z;
			binInner.y = transformedBin.position.y;

			binSprite.x = this.orientation === 'FRONT' ? binInner.x - this.shelfBorderThickness : binInner.x;
			binSprite.y = binInner.y - this.shelfBorderThickness;
			binSprite.width =
				this.orientation === 'FRONT'
					? binXAxisLength + this.shelfBorderThickness * 2
					: binXAxisLength + this.shelfBorderThickness;
			binSprite.height = transformedBin.height + this.shelfBorderThickness * 2;
			this.app.stage.addChild(binSprite);
			this.app.stage.addChild(binInner);
		});
	}
	createDimensionGroup(value, x, y, wording, direction = 'horizontal') {
		const container = new PIXI.Container();
		const arrowTexture = this.assetLoader.get(this.shelfSizingArrowImageUrl);
		if (!arrowTexture) return container;
		const label = new PIXI.Text(`${wording}: ${value} cm`, {
			fontFamily: 'objektiv-variable, sans-serif, sans-serif',
			fontSize: 12,
			fill: '#000000',
		});
		label.anchor.set(0.5, 0.5);
		const arrow1 = new PIXI.Sprite(arrowTexture);
		arrow1.anchor.set(0.5, 0.5);
		arrow1.width = this.arrowSize;
		arrow1.height = this.arrowSize;

		const arrow2 = new PIXI.Sprite(arrowTexture);
		arrow2.anchor.set(0.5, 0.5);
		arrow2.width = this.arrowSize;
		arrow2.height = this.arrowSize;

		if (direction === 'horizontal') {
			// arrow asset is horizontal right
			arrow1.rotation = Math.PI;
			arrow1.x = -label.width / 2 - this.arrowSpacing - this.arrowSize / 2;
			arrow2.x = label.width / 2 + this.arrowSpacing + this.arrowSize / 2;
		} else {
			arrow1.rotation = -Math.PI / 2; // Up
			arrow2.rotation = Math.PI / 2; // Down
			label.rotation = -Math.PI / 2;
			arrow1.y = -label.width / 2 - this.arrowSpacing - this.arrowSize / 2;
			arrow2.y = label.width / 2 + this.arrowSpacing + this.arrowSize / 2;

			label.x = -2; // aligning label to arrows tails
		}
		container.addChild(arrow1, label, arrow2);
		container.x = x;
		container.y = y;
		return container;
	}

	drawSizingArrows() {
		if (!this.shelf || !this.app) return;
		this.shelf.bins.forEach((bin) => {
			const transformedBin = bin.transformToPixiJs(this.TransformFactor);
			const binWidth = this.orientation === 'FRONT' ? bin.width : bin.depth;
			const binWidthWording = this.orientation === 'FRONT' ? this.widthWording : this.depthWording;
			const binHeight = bin.height;
			const binWidthCm = binWidth / 10.0;
			const binHeightCm = binHeight / 10.0;
			const transformedBinWidth = this.orientation === 'FRONT' ? transformedBin.width : transformedBin.depth;

			if (bin.position.y === 0) {
				const widthGroup = this.createDimensionGroup(
					binWidthCm,
					transformedBin.position.x + transformedBinWidth / 2,
					transformedBin.position.y + transformedBin.height + this.shelfBorderThickness + this.arrowOffset,
					binWidthWording,
					'horizontal',
				);
				this.app.stage.addChild(widthGroup);
			}
			if (bin.position.x === 0) {
				const heightGroup = this.createDimensionGroup(
					binHeightCm,
					transformedBin.position.x - this.shelfBorderThickness - this.arrowOffset,
					transformedBin.position.y + transformedBin.height / 2,
					this.heightWording,
					'vertical',
				);
				this.app.stage.addChild(heightGroup);
			}
		});
	}
	drawJars() {
		if (!this.app || !this.shelf) return;
		this.placements.forEach((placement) => {
			const imageUrl = this.imageMap[placement.variantID];
			if (!imageUrl) return;
			const sprite = new PIXI.Sprite(this.assetLoader.get(imageUrl));
			const transformedPlacement = placement.transformToPixiJs(this.TransformFactor);
			sprite.x = this.orientation === 'FRONT' ? transformedPlacement.position.x : transformedPlacement.position.z;
			sprite.y = transformedPlacement.position.y;
			sprite.width = this.orientation === 'FRONT' ? transformedPlacement.width : transformedPlacement.depth; //transformedPlacement.width;
			sprite.height = transformedPlacement.height;
			this.app.stage.addChild(sprite);
		});
	}
}
customElements.define('shelf-visualization', ShelfVisualization);
